import { Field as FormikField } from 'formik';
import React from 'react';

import focusHandler from '../../utils/focusHandler';

export default function FormikTextField(props) {
  return <FormikField {...props} onKeyDown={(e) => focusHandler(e)} />;
}
